import { Field } from "./field";
import { cr } from "fire-wind-water";

class Desc extends Field {
  displaySelectType: string;
  displayType: number;

  constructor(field: unknown) {
    super(field);
    const attr = ["extraConfig"];
    cr.each(attr, (d) => {
      this[d] = field[d];
    });
    this.displaySelectType = "DESC";
    this.displayType = 120;
    this.invalid = false;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setValue(): void {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  initValue(): void {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  clearValue(): void {}
}

export { Desc };
